export const REJECT_QUICK_REASONS = [
  "סוג הפעולה לא מתאים",
  "האבחון שגוי",
  "הלקוח כבר בטיפול",
  "חסר מידע לפני פעולה",
];
